import React, { Component } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import CustomStore from "devextreme/data/custom_store";
import { buildRequestParameters } from "../../services/RemoteOperationsService";
import { LoadPanel } from "devextreme-react";
import SimpleGridService, { GridTypes } from "../../services/SimpleGridService";
import ShiftMatrixGridContents from "./ShiftMatrixGridContents";
import sharedUtils from "../../components/grid/sharedUtilities";


interface FutureNegativeShiftGridProps extends WithTranslation {
    id: string;
    payDate?: Date | null | undefined;
    updateClicked?: (isClicked: boolean) => void;
    pageType?:string;
}

interface FutureNegativeShiftGridState {
    dataSource: [],
    loadIndicatorForGrid: boolean
}

class FutureNegativeShiftGrid extends Component<FutureNegativeShiftGridProps> {
    state: FutureNegativeShiftGridState;
    service: SimpleGridService;
    utils: sharedUtils
    constructor(props: FutureNegativeShiftGridProps) {
        super(props);
        this.state = {
            dataSource: [],
            loadIndicatorForGrid: false
        }
        this.service = new SimpleGridService();
        this.utils  = new sharedUtils()
    }

    getResults = (loadOptions: any) => {
        let params = buildRequestParameters(loadOptions);
        if(this.props.pageType==="PaymentsPreview"){
            let paymentDate = this.utils.convertDateToString(this.props.payDate)
            return this.service.getFutureShiftGridRowsWithinRemoteOperations_PreviewPage(params,paymentDate)
            .then(this.handleSuccessLoadDataSource)
            .catch(() => { throw 'Data Loading Error'; });
        }else{
        return this.service.getFutureShiftGridRowsWithinRemoteOperations(params, this.props.id)
            .then(this.handleSuccessLoadDataSource)
            .catch(() => { throw 'Data Loading Error'; });
        }
    }

    handleSuccessLoadDataSource = (response: any) => {
        this.setState({
            loadIndicatorForGrid: false
        });
        const transformDoNotPay = (items: any[]) => {
        return items.map((item: any) => ({
            ...item,
            pay: item.pay? "Yes" : "No"
        }));
    };
        if ((response.data.data && response.data.data.billableItemRemoteGrid) || response.data.data.billableItemRemoteGrid == null) {
            return {
                data: response.data.data.billableItemRemoteGrid ? transformDoNotPay(response.data.data.billableItemRemoteGrid) : [],
                totalCount: response.data.data.totalCount
            };

        }
        else {
            return {
                data: response.data.data ? transformDoNotPay(response.data.data) : [],
                totalCount: response.data.totalCount
            };
        }
    }

    componentDidMount() {
        this.setState({
            loadIndicatorForGrid: true
        });
        this.loadDataSource();
    }

    componentDidUpdate(prevProps: FutureNegativeShiftGridProps) {
        if (this.props.id != prevProps.id) {
            this.loadDataSource();
        }

    }

    loadDataSource = () => {
        let dataSource = new CustomStore({
            key: "id",
            load: this.getResults,
        });

        this.setState({
            dataSource: dataSource,
            loadIndicatorForGrid: false
        });
    }


    render() {
        return (
            <div>
                <LoadPanel shadingColor="rgba(0,0,0,0.4)" visible={this.state.loadIndicatorForGrid} />
                <ShiftMatrixGridContents dataSource={this.state.dataSource} navigateFrom={GridTypes.futureNegetiveShift} paymentId={this.props.id} payDate={this.props.payDate} updateClicked={this.props.updateClicked}/>
            </div>
        );
    }
}

export default withTranslation()(FutureNegativeShiftGrid);